import { Component, Input } from '@angular/core';

import { simpleFadeAnimation } from './overlay-transition-animation';

@Component({
  selector: 'app-overlay-transition',
  templateUrl: './overlay-transition.component.html',
  styleUrls: ['./overlay-transition.component.scss'],
  animations: [simpleFadeAnimation],
  standalone: false,
})
export class OverlayTransitionComponent {
  @Input() public overlayText = '';
  @Input() public isFullOverlay = true;
  @Input() public transitionTimeout = 3000;
}
